export default "__VITE_ASSET__CwWKINh0__"